/** Role helpers for admin / operations / finance / executive. */

const ROLES = {
  admin: 'admin',
  operations: 'operations',
  finance: 'finance',
  executive: 'executive',
};

export function normalizeRole(user) {
  return String(user?.role || '').toLowerCase();
}

export function isAdmin(user) {
  return normalizeRole(user) === ROLES.admin;
}

export function isExecutive(user) {
  const r = normalizeRole(user);
  return r === ROLES.executive || r === ROLES.admin;
}

export function isFinance(user) {
  const r = normalizeRole(user);
  return r === ROLES.finance || r === ROLES.admin || r === ROLES.executive;
}

export function isOperations(user) {
  const r = normalizeRole(user);
  return r === ROLES.operations || r === ROLES.admin || r === ROLES.executive;
}

export function canWriteDeals(user) {
  return isOperations(user) || isExecutive(user);
}

export function canAuthorisePayments(user) {
  return isFinance(user);
}

export function canManageRegisters(user) {
  return isAdmin(user) || isExecutive(user) || isOperations(user);
}

export function canViewKpis(user) {
  return isAdmin(user) || isExecutive(user) || isOperations(user) || isFinance(user);
}

export function roleLabel(user) {
  const r = normalizeRole(user);
  if (!r) return '';
  return r.charAt(0).toUpperCase() + r.slice(1);
}
